<template>
  <div>
    <div class="site-banner">
      <div class="banner-major">
        <div class="container">
          <div class="site-banner-product">
            <div class="site-banner-detail">
              <div class="detail-box-left">
                <h3 v-text="item.section_value.titlecenter_title" />
                <h5 v-text="item.section_value.titlecenter_subtitle" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['currentUrl'])
  },
}
</script>

<style lang="scss" scoped>
</style>